import React from "react"
import classnames from "classnames";

import HooversModal from "@/app/pages/contactProfile/HooversModal";
import { isNotUndefinedOrNull } from "@/shared/FunctionCore";
interface Iprops {
  title: string,
  blockName?: string,
  blockId: string,
  rightHandSubtitle?: JSX.Element,
  onClickModalButton?: (flag: "close" | "open") => void,
  showModal?: boolean | undefined,
  children: React.ReactNode,
}

const Paper = ({
  title,
  rightHandSubtitle,
  blockName,
  blockId,
  onClickModalButton,
  showModal,
  children
}: Iprops): JSX.Element => (
  <div
    id={blockId}
    className={classnames(blockId, "overview-component", {
    // blockId class name for anchors click scroll transitions
    "movers-mobile-bg-green": blockName === "moversAndShakers",
  })}>
    <div className={classnames({
      "container box-shadow-component hide-box-shadow-mobile contact-component-wrapper": true,
      "colleaguesWrapper": blockName === "colleagues",
      "moversWrapper": blockName === "moversAndShakers",
      "mobile-margin-lr": blockName === "faqs"
    })}>
      <div className="row pl-10">
        <h3 className={classnames({
          "component-title": true,
          "col-md-6 col-xs-12": blockName === "contact-profile-overview",
          "col-xs-12": blockName === "faqs"
        })}>
          {title || "Overview"}
        </h3>
        {rightHandSubtitle}
      </div>
      <hr className="title-bottom-line mx-minus-1" />
      {children}
    </div>
    {isNotUndefinedOrNull(onClickModalButton) && (
      <HooversModal
        onClickModalButton={onClickModalButton}
        showModal={showModal}
      />
    )}
  </div>
)

export default Paper